module.exports = __webpack_public_path__ + "assets/img/f9cf69f4f43f5ef691cc3fb03f1df650.svg";